export class Instanceparent {
    name: string;
    info: Array<Instancechild>;
    id: number;
    constructor() {
        this.info = [];
    }
}
export class Instancechild {
    id: number;
    info: string;
    description: string;
    isCheck: boolean = false;
}
export class InstanceparentList {
    InstanceList: Array<Instanceparent>;
    // InstanceparentList: any;
    constructor() {
        this.InstanceList = [];
    }
}
